import { render } from "./AdminViewLiquidation.vue?vue&type=template&id=03fd1b3e"
import script from "./AdminViewLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminViewLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__